// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setYAxisMetric = createAction('[Scatter Plot] Set Y Axis Metric', props());
